import { type UserType } from 'app/entities';

const userFullName = (user: UserType) => `${user.name} ${user.surname}`.trim() || user.login;

export default userFullName;
